module.exports = __webpack_public_path__ + "media/src/website/images/locations/germering/04-3fdde513acd47c43a5defc51e168561f.jpg";